import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageReportsListProps = {
  // TODO: add props here
};

const PageReportsList: React.FC<PageReportsListProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="reportsList">
      <div className="h-full overflow-y-auto">
        <h1 className="mt-2 mb-3 text-center text-3xl font-bold">
          {t("Reports List")}
        </h1>
      </div>
    </BasePage>
  );
};

export default PageReportsList;
